import type { AuthMeResponse, DetailsStatusResponse, MessagePayload, PublicStatusResponse, StatusMessageDto } from './types';

async function fetchJson<T>(input: RequestInfo, init?: RequestInit): Promise<T> {
  const resp = await fetch(input, { credentials: 'same-origin', ...init });
  if (!resp.ok) {
    const err = new Error(`HTTP ${resp.status}`) as Error & { status?: number };
    err.status = resp.status;
    throw err;
  }
  return resp.json() as Promise<T>;
}

export async function getStatus(): Promise<{ details?: DetailsStatusResponse; publicView?: PublicStatusResponse; isAdmin: boolean }> {
  try {
    const details = await fetchJson<DetailsStatusResponse>('/api/status/details');
    return { details, isAdmin: true };
  } catch (e) {
    const err = e as Error & { status?: number };
    if (err.status !== 401) throw err;
    const publicView = await fetchJson<PublicStatusResponse>('/api/status');
    return { publicView, isAdmin: false };
  }
}

export function createMessage(payload: MessagePayload): Promise<StatusMessageDto> {
  return fetchJson('/api/messages', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function updateMessage(id: number, payload: MessagePayload): Promise<StatusMessageDto> {
  return fetchJson(`/api/messages/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function deleteMessage(id: number): Promise<void> {
  const resp = await fetch(`/api/messages/${id}`, { method: 'DELETE', credentials: 'same-origin' });
  if (!resp.ok && resp.status !== 204) throw new Error(`HTTP ${resp.status}`);
}

export function getAuthMe(): Promise<AuthMeResponse> {
  return fetchJson<AuthMeResponse>('/auth/me');
}

export async function logout(): Promise<void> {
  await fetch('/auth/logout', { method: 'POST', credentials: 'same-origin' });
}
